import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";

export interface ConfirmDeleteThreadDialogData {
  threadName: string;
}

/**
 * Simple confirmation dialog before deleting a conversation thread.
 * Returns true when the user confirms, undefined/false on cancel.
 */
@Component({
  selector: "app-confirm-delete-thread-dialog",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButton],
  template: `
    <h2 mat-dialog-title>Delete conversation</h2>
    <mat-dialog-content>
      <p>
        Delete <strong>{{ data.threadName }}</strong
        >?
      </p>
      <p class="mat-font-body-sm text-secondary">This cannot be undone.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">Cancel</button>
      <button mat-flat-button color="warn" [mat-dialog-close]="true">Delete</button>
    </mat-dialog-actions>
  `,
})
export class ConfirmDeleteThreadDialogComponent {
  protected readonly data = inject<ConfirmDeleteThreadDialogData>(MAT_DIALOG_DATA);
}
